var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25,
    fill: "none",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M13.295 2.992h3.841c1.554 0 2.819 1.28 2.819 2.853v.146c0 1.202-.74 2.23-1.782 2.65v13.477c0 1.573-1.264 2.852-2.819 2.852H4.601c-1.555 0-2.82-1.28-2.82-2.852V8.64C.74 8.22 0 7.193 0 5.99v-.146c0-1.573 1.264-2.853 2.819-2.853H6.66C6.852 1.31 8.265 0 9.977 0c1.713 0 3.126 1.31 3.318 2.992zm-1.351 0c-.18-.933-.993-1.639-1.967-1.639-.973 0-1.786.706-1.966 1.639h3.933zm4.892 19.126c0 .827-.665 1.5-1.482 1.5H4.601c-.817 0-1.482-.673-1.482-1.5V8.844h13.717v13.274zm.3-14.627c.817 0 1.482-.673 1.482-1.5v-.146c0-.827-.665-1.5-1.482-1.5H2.819c-.817 0-1.482.673-1.482 1.5v.146c0 .827.665 1.5 1.482 1.5h14.317z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M6.393 21.887c.37 0 .669-.303.669-.676v-7.617c0-.373-.3-.676-.669-.676-.369 0-.668.303-.668.676v7.617c0 .373.3.676.668.676zM9.977 21.887c.37 0 .669-.303.669-.676v-7.617c0-.373-.3-.676-.669-.676-.369 0-.668.303-.668.676v7.617c0 .373.3.676.668.676zM13.562 21.887c.369 0 .668-.303.668-.676v-7.617c0-.373-.3-.676-.668-.676-.37 0-.669.303-.669.676v7.617c0 .373.3.676.669.676z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/delete-button.65e663c12effb96fac722fa675fa404d.svg";
export { ForwardRef as ReactComponent };